import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IFrontReport } from '../interfaces/report-fronts';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommunicationService } from 'src/app/services/communication';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { CacheService } from 'projects/common/src/app/services/cache.service';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportFrontService {
  private baseUrl: string;
  constructor(
    private http: HttpClient,
    private _communicationService: CommunicationService,
    private _cacheService: CacheService,
    private urlBuilder: UrlBuilderService,
  ) {
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   *  Function to get detail of fronts.
   */
  public getFrontsData(params): Promise<IFrontReport[]> {
    const url = `${this.baseUrl}/Report/GetStatusFrontReport`;
    return this._communicationService.get(url, params).toPromise();
  }

  /**
   * Function to get download report
   */
  public getStatusFrontReportDocument(selectedFilters): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetStatusFrontReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * set Params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this._cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      companyId,
      shiftId: selectedFilters.shiftId,
      zoneList: selectedFilters.zoneId,
      frontList: selectedFilters.frontId,
    };
  }
}
